<template>
  <BasePopupModal :modal="modal" :overlay-color="'white'" :width="900">
    <div class="add-agent-modal">
      <div class="add-agent-modal--header font-weight-light">Ajout d'un agent</div>
      <div class="add-agent-modal--content">
        <div class="add-agent-modal--content-label font-weight-medium">Ajout d'agent(s)</div>
        <div class="d-flex justify-center">
          <div v-if="isShowSelect" class="add-agent-modal--content-list">
            <v-select v-model="selectedAgent" :items="agents" item-value="id" filled label="Filled style">
              <template slot="selection" slot-scope="data">
                {{ data.item.lastname }} {{ data.item.firstname }} - {{ data.item.enterpriseName }} - {{ data.item.profileName }}
              </template>
              <template slot="item" slot-scope="data">
                {{ data.item.lastname }} {{ data.item.firstname }} - {{ data.item.enterpriseName }} - {{ data.item.profileName }}
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="add-agent-modal--buttons d-flex justify-end">
        <v-btn class="add-agent-modal--buttons-cancel" outlined depressed @click="close"> Annuler </v-btn>
        <v-btn class="add-agent-modal--buttons-save" color="#38BB00" :disabled="isDisabled" dark depressed @click="submit"> Valider </v-btn>
      </div>
    </div>
  </BasePopupModal>
</template>

<script>
import BasePopupModal from '@/components/modals/base/BasePopupModal';

export default {
  name: 'AddAgentModal',
  components: {
    BasePopupModal
  },
  props: {
    modal: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedAgent: null
    };
  },
  computed: {
    agents() {
      return this.modal.payload.agents;
    },
    isShowSelect() {
      return this.agents.length;
    },
    isDisabled() {
      return !this.selectedAgent;
    }
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.modal.payload.submit(this.selectedAgent);
      this.close();
    }
  }
};
</script>

<style lang="scss">
.modals-container {
  border: 1px solid #ffffff;
}
.add-agent-modal {
  .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgb(56, 187, 0, 0.6) !important;
    border-color: rgb(56, 187, 0, 0.6) !important;
  }

  &--header {
    text-align: center;
  }

  &--content {
    text-align: center;
    margin-top: 10px;
    height: 343px;
    border: 1px solid #e4e6e8;
    border-radius: 10px;

    &-list {
      width: 60%;
      margin-top: 40px;
    }

    &-label {
      font-size: 18px;
      margin-top: 66px;
      text-align: center;
    }

    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
      background-color: white !important;
    }
  }

  &--buttons {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;

    button {
      padding: 10px 0 10px;
      height: 38px;
      width: 121px;
      border-radius: 10px;
      font-size: 14px;
      border: 1px solid #e2e2ea;
      font-weight: 600;
      font-size: 14px;
      text-transform: none;
    }

    &-cancel {
      margin-right: 8px;
      color: #696974 !important;
    }
  }
}
</style>
